module.exports = __webpack_public_path__ + "media/martin-codax.748b364c.mp4";